module.exports = __webpack_public_path__ + "img/hand-heart-fill.ac7e022c.svg";